import React, { FunctionComponent } from 'react';
import { ApolloProvider } from 'react-apollo';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';

import { client } from '@trello/graphql';

// eslint-disable-next-line no-restricted-imports
import history from 'common/history';
// eslint-disable-next-line no-restricted-imports
import { MarkdownContext } from 'components/trello-markdown';
import { defaultStore } from 'defaultStore';
// eslint-disable-next-line no-restricted-imports
import { TrelloMarkdownWrapper } from 'util/trello-markdown-config';

const markdownWrapper = new TrelloMarkdownWrapper(defaultStore);

export const ComponentWrapper: FunctionComponent = ({ children }) => (
  // Wrap these elements in a parent with the magic class that suppresses the
  // global click-handling logic (see doc-init.js#domReady method)
  <div className="js-react-root">
    <ApolloProvider client={client}>
      <Provider store={defaultStore}>
        <MarkdownContext.Provider value={markdownWrapper}>
          <ConnectedRouter history={history}>{children}</ConnectedRouter>
        </MarkdownContext.Provider>
      </Provider>
    </ApolloProvider>
  </div>
);



// WEBPACK FOOTER //
// ./app/gamma/src/components/ComponentWrapper.tsx